import { render, staticRenderFns } from "./OpinionScoreView.vue?vue&type=template&id=c9989962&scoped=true&"
import script from "./OpinionScoreView.vue?vue&type=script&lang=js&"
export * from "./OpinionScoreView.vue?vue&type=script&lang=js&"
import style0 from "./OpinionScoreView.vue?vue&type=style&index=0&id=c9989962&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9989962",
  null
  
)

export default component.exports